import React from 'react'

import { Field } from 'components/_new/forms'
import type { FieldProps } from 'components/_new/forms'

import messages from './messages'
import s from './PasswordField.scss'


type PasswordFieldProps = Pick<FieldProps, 'field' | 'id' | 'label' | 'autoComplete' | 'standardView' | 'onBlur'>


// TODO remove className, add "icon" prop to StandardInputView
const PasswordField: React.FunctionComponent<PasswordFieldProps> = (props) => {
  const {
    id = 'passwordRegister', label = messages.label, field, standardView, autoComplete, onBlur,
  } = props

  return (
    <Field
      id={id}
      type="password"
      field={field}
      label={standardView ? null : label}
      placeholder={standardView ? label : null}
      className={standardView ? s.withLockIcon : null}
      standardView={standardView}
      autoComplete={autoComplete}
      dataTestId="passwordField"
      onBlur={onBlur}
    />
  )
}


export default PasswordField
